import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import { useLanguage, translations } from "@/i18n/LanguageContext";

const AboutSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const { t } = useLanguage();

  return (
    <section id="om-envir" ref={ref} className="section-padding py-24 md:py-36 bg-background">
      <div className="grid md:grid-cols-2 gap-16 md:gap-24 max-w-7xl mx-auto">
        <motion.div initial={{ opacity: 0, x: -30 }} animate={isInView ? { opacity: 1, x: 0 } : {}} transition={{ duration: 0.8 }}>
          <span className="text-sm font-body font-500 tracking-widest uppercase text-primary mb-4 block">{t(translations.about.label)}</span>
          <h2 className="heading-lg text-foreground text-balance">{t(translations.about.title)}</h2>
        </motion.div>
        <motion.div initial={{ opacity: 0, x: 30 }} animate={isInView ? { opacity: 1, x: 0 } : {}} transition={{ duration: 0.8, delay: 0.2 }} className="flex flex-col justify-end gap-6">
          <p className="body-lg text-muted-foreground whitespace-pre-line">{t(translations.about.description)}</p>
          <a
            href="/om-oss"
            className="inline-flex items-center gap-2 text-primary font-display font-500 text-sm tracking-wide hover:gap-3 transition-all duration-300"
          >
            {t(translations.about.contactCta)} <ArrowUpRight className="w-4 h-4" />
          </a>
        </motion.div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-px mt-20 md:mt-28 max-w-7xl mx-auto bg-border">
        {translations.about.stats.map((stat, i) => (
          <motion.div key={i} initial={{ opacity: 0, y: 20 }} animate={isInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.6, delay: 0.4 + i * 0.1 }} className="bg-background p-6 md:p-8">
            {('title' in stat && stat.title) ? (
              <span className="text-3xl md:text-4xl xl:text-3xl 2xl:text-4xl font-display font-700 leading-none tracking-tighter text-primary block mb-3">{t(stat.title)}</span>
            ) : stat.number ? (
              <span className="text-3xl md:text-4xl xl:text-3xl 2xl:text-4xl font-display font-700 leading-none tracking-tighter text-primary block mb-3">{stat.number}</span>
            ) : null}
            <span className="text-sm font-body font-300 leading-relaxed text-muted-foreground">{t(stat.label)}</span>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default AboutSection;
